<div class="table-container">
  <div class="data-card">
    <div class="table-wrapper">
      <table mat-table [dataSource]="dataSource" matSort>

        <!-- Commercial Office Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Commercial Office </th>
          <td mat-cell *matCellDef="let row"> {{row.description}} </td>
        </ng-container>

        <!-- External ID Column -->
        <ng-container matColumnDef="externalId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> External ID </th>
          <td mat-cell *matCellDef="let row"> {{row.externalId}} </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Actions </th>
          <td mat-cell *matCellDef="let row">
            <div class="actions">
              <button matButton class="act-btn" (click)="onEditOffice(row)" matTooltip="Edit Office">
                <i class="fa-solid fa-pen"></i>
              </button>
              <button matButton class="act-btn danger" (click)="onDeleteOffice(row)" matTooltip="Delete Office">
                <i class="fa-regular fa-trash-can"></i>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <mat-paginator
      [pageSizeOptions]="[10, 25, 50, 100]"
      showFirstLastButtons
      aria-label="Select page">
    </mat-paginator>
  </div>

  <button class="fab fab-left" (click)="onNewOffice()">
    <i class="fa-solid fa-plus"></i>
    New Office
  </button>

</div>
